import { gql } from '@apollo/client'

export const RemoveChat = gql`
    mutation RemoveChat($roomId: ID!, $chatId: ID!) {
        removeChat(roomId: $roomId, chatId: $chatId) {
            actor {
                id
                username
            }
            id
            updated
        }
    }
`

export default RemoveChat

